import { Box, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

export interface SheetHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  pb?: string;
}

export const SheetHeader = ({ title, subtitle, pb = "16px" }: SheetHeaderProps) => (
  <Box px="20px" pt="4px" pb={pb}>
    <Text
      as="h2"
      m="0"
      fontFamily="body"
      fontSize="22px"
      fontWeight="semibold"
      color="fg.default"
      letterSpacing="-0.015em"
      lineHeight="1.2"
    >
      {title}
    </Text>
    {subtitle && (
      <Text
        m="6px 0 0"
        fontFamily="body"
        fontSize="13.5px"
        color="fg.muted"
        lineHeight="1.5"
      >
        {subtitle}
      </Text>
    )}
  </Box>
);
